import {
  IMockProps,
  ErrorResponseCodeType,
  MockServiceType,
  Mocks,
  BussinessErrorLocalType,
} from '../../Core';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../../Apis/ZipCodeApi';
import { IZipCodeServiceRequest } from '../../Types/ZipCode.types';

const ZIP_CODE = '30350199';

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

/** Mocks de Erro */
let mocksErrors: IMockProps[] = [];

const generateSuccess = (zipCode: string): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params: {
        zipcode: zipCode,
      },
    },
    configResponse: {
      status: 200,
      data: {
        city: 'BELO HORIZONTE',
        country: 'Brazil',
        state: 'MG',
        streetName: 'ABRE CAMPO',
        zipCode,
      },
      headers: {},
    },
  };
};

mocksSuccess.push(generateSuccess(ZIP_CODE));

const generateDefaultErrors = (zipcode: string): IMockProps[] => {
  return CODE_ERRORS.map(
    (
      error: ErrorResponseCodeType<BussinessErrorLocalType>,
      index: number,
    ): IMockProps => {
      return {
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          body: {},
          params: {
            zipcode: `${zipcode.slice(0, -1)}${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };
    },
  );
};

mocksErrors = mocksErrors.concat(generateDefaultErrors(ZIP_CODE));

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

export const mocksService: MockServiceType<IZipCodeServiceRequest>[] =
  allMocks.map((request) => {
    return {
      label: `[Sucesso] - CEP: ${request.configRequest.params.zipcode}`,
      value: request.configRequest.params,
    };
  });

Mocks.getInstance().addAll(allMocks);
